import { GenericObj } from '@solvhealth/types/interfaces/generics';
import { useTranslation } from 'react-i18next';
import { useSolvSelector } from '~/reducers';
import { isPaperworkForChild } from '~/components/Paperwork/util';
import { SectionNumber } from '../constants';
import { PGSectionNumber } from '../providerGroups/constants';
import { PageNumber, SectionNumberObj } from '../interfaces';

const getPageTitleKeys = <Sect extends SectionNumber | PGSectionNumber>(
  sectionValue: Sect,
  section: SectionNumberObj<Sect>,
  pageNumber: PageNumber,
  isMinor: boolean
) => {
  if (
    (sectionValue === SectionNumber.Custom ||
      sectionValue === SectionNumber.VerificationAndReview) &&
    section !== PGSectionNumber
  ) {
    return { titleKey: `${sectionValue}.genericTitle`, subtitleKey: `${sectionValue}.subtitle` };
  }
  const titleKey = `${sectionValue}.pages.${pageNumber}.${
    isMinor ? 'personalTitle' : 'genericTitle'
  }`;
  const subtitleKey = `${sectionValue}.pages.${pageNumber}.subtitle`;
  return { titleKey, subtitleKey };
};

export const useTitles = <Sect extends SectionNumber | PGSectionNumber>(
  sectionValue: Sect,
  section: SectionNumberObj<Sect>,
  interpolations: GenericObj
) => {
  const paperwork = useSolvSelector((state) => state.paperwork);
  const { t } = useTranslation(
    section === PGSectionNumber ? 'providerGroupPaperwork' : 'paperwork'
  );

  const isMinor = isPaperworkForChild(paperwork.formData);
  const { titleKey, subtitleKey } = getPageTitleKeys(
    sectionValue,
    section,
    paperwork.pageView,
    isMinor
  );

  const title = t(titleKey as any, interpolations);
  const subtitle = t(subtitleKey as any);

  return [title, subtitle] as const;
};
